<template>
<v-container>
  <v-layout row v-if="loading">
    <progress-dialog>{{ $t('loading') }}</progress-dialog>
  </v-layout>
  <v-layout row justify-center v-else>
    <v-flex>
      <v-data-table :headers="headers" :items="items" :no-data-text="$t('activity.no_data')" disable-initial-sort hide-actions class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ new Date(props.item.timestamp).toLocaleString() }}</td>
          <td nowrap>{{ props.item.platform }}</td>
          <td nowrap>{{ props.item.cmd }}</td>
          <td nowrap>{{ props.item.mac }} {{ props.item.uid }} {{ props.item.cid }} {{ props.item.val }}</td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import {
  UserAuth
} from 'luffanet-web-components'

const ROWS = 50;

export default {
  name: 'Activity',
  mixins: [UserAuth],
  data: function() {
    return {
      loading: true,
      headers: [{
        text: this.$t('activity.timestamp'),
        value: 'timestamp',
        sortable: false
      }, {
        text: this.$t('activity.platform'),
        value: 'platform',
        sortable: true
      }, {
        text: this.$t('activity.command'),
        value: 'cmd',
        sortable: true
      }, {
        text: this.$t('activity.content'),
        sortable: false
      }],
      items: []
    }
  },
  methods: {
    load() {
      this.$bindAsArray('items', this.$db.ref('activity').child(this.userId).limitToFirst(ROWS), null, function() {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
.uppercase {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/activity.vue